import * as req from 'api/actions';
import * as c from './constants';

export const getDiscountAndPenalty = (payload, callback) =>
  req.list(
    c.GET_DISCOUNT_AND_PENALTY,
    'api/v1/administrators/rpt_discount_penalty_settings',
    payload,
    callback
  );

export const updateDiscountAndPenalty = (id, payload, callback) =>
  req.update(
    c.UPDATE_DISCOUNT_AND_PENALTY,
    `api/v1/administrators/rpt_discount_penalty_settings/${id}`,
    payload,
    callback
  );


